import styles from "./MenuLayoutEdit.module.css";
import React, { useState, useRef, useEffect } from "react";

export default function TabTitle(props) {
  const { name, index, count, addTab, removeTab, setTabName, isFocus } = props;
  const inputEl = useRef(null);
  useEffect(() => {
    isFocus &&
      inputEl &&
      inputEl.current &&
      inputEl.current.focus &&
      inputEl.current.focus();
  }, [isFocus, inputEl]);
  return (
    <h2>
      <div onKeyDown={(e) => e.stopPropagation()}>
        <span className={styles.textBoxTabTitleSizer} aria-hidden="true">
          {name}
        </span>
        <input
          ref={inputEl}
          className={styles.textBoxTabTitle}
          value={name}
          onChange={(event) => setTabName(event.target.value)}
          maxLength="20"
        />
        <span
          role="button"
          aria-label="Remove"
          className="k-icon k-i-trash"
          onClick={() => removeTab()}
        ></span>
        {index === count - 1 ? (
          <span
            role="button"
            aria-label="Add"
            className="k-icon k-i-plus"
            onClick={addTab}
          />
        ) : undefined}
      </div>
    </h2>
  );
}
